export class Payment {
    orderId: string;
    payerId: string;
    status: string;
    productId: string;
    createTime: string;
    payerCountryCode: string;
    payerEmailAddress: string;
    name: string;
    surname: string;
    amountValue: number;
    currencyCode: string;
}